module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_vm._v("PUBLISHER’S NOTE: This is a work of fiction. Names, characters, places, and incidents are either the product of the author’s imagination or used fictitiously, and any resemblance to actual persons, living or dead, business establishments, events, or locales is entirely coincidental.")])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Cataloging-in-Publication Data has been applied for and may be obtained from the Library of Congress.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Paperback ISBN 978-1-4197-2010-9"), _c('br'), _vm._v("eISBN: 978-1-6833-5154-2")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Text copyright © 2007, 2017 Michael Buckley"), _c('br'), _vm._v("Illustrations copyright © 2007 Peter Ferguson"), _c('br'), _vm._v("Book design by Chad W. Beckerman and Siobhan Gallagher")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Originally published in hardcover in 2007 by Amulet Books, an imprint of ABRAMS. This edition published in 2017 by Amulet Paperbacks. All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, mechanical, electronic, photocopying, recording, or otherwise, without written permission from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Amulet Books and Amulet Paperbacks are registered trademarks of Harry N. Abrams, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Amulet Books are available at special discounts when purchased in quantity for premiums and promotions as well as fundraising or educational use. Special editions can also be created to specification. For details, contact specialsales@abramsbooks.com or the address below.")])]), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/copy.jpg"
    }
  }), _c('br'), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("ABRAMS")])]), _vm._v(" The Art of Books"), _c('br'), _vm._v("115 West 18th Street, New York, NY10011"), _c('br')]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.abramsbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("abramsbooks.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fad2c05a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copy.vue
// module id = 60
// module chunks = 0